import Box from '@paperstac/ui/lib/Box';
import React from 'react';

const defaultSx = {
  fontSize: 1,
  mb: 3,
  py: 2,
  px: 3,
  border: 'default',
  borderColor: 'blue',
  borderRadius: 'corner',
  bg: 'gray.1',
};

const InfoMessage = React.memo(({ sx = defaultSx, ...props }) => <Box sx={sx} {...props} />);

InfoMessage.propTypes = {};

InfoMessage.displayName = 'InfoMessage';

export default InfoMessage;
